module.exports = __webpack_public_path__ + "img/ico-security.4d9256f6.svg";